import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './navbar.css';
import styles from './navbar.module.css';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../assets/logowhite.png';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAllCart, deleteCart } from '../Redux/CartSlice';
import { clearUserID, setUserToggle } from '../Redux/UserSlice';
import { toast } from 'react-toastify';
import axios from 'axios'; 

function Navbar(props) {
  const [isSearchFocused, setSearchFocused] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const dispatch = useDispatch();

  const handleSearchFocus = () => {
    setSearchFocused(true);
  };

  const handleSearchBlur = () => {
    setSearchFocused(false);
  };

  const handleSidebarBlur = () => {
    setSidebarOpen(false);
  }

  const handleSidebarToggle = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const sidebarClassName = `navlink ${isSidebarOpen ? 'open' : ''}`;
  const searchClassName = `searchbar ${isSearchFocused ? 'focused' : ''}`;

  const navigate = useNavigate();
  const goToCart = () => {
    navigate('/cart');
  }

  ///////////////////////////////////
  const userID = useSelector((state) => state.user.userID);

  const [color, setColor] = useState("");
  const [loginOut, setLoginOut] = useState("Login");
  useEffect(() => {
    if (userID) {
      setLoginOut("Logout");
      setColor("#FF2400");
    } else {
      setLoginOut("Login");
      setColor("");
    }
  }, [userID]);

  const notify = () => {
    toast(`You're now logged out.`, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  const handleLoginOut = () => {

    if (loginOut === "Login") {
      dispatch(setUserToggle());
      navigate("/login");
    }
    else {
      notify();
      dispatch(deleteAllCart());
      dispatch(clearUserID());
    }
  }


  const handleSearchPress = () => {
    navigate('/searchresults', {state: {searchQuery}})
  }

  const handleUserDashboard = () =>{
    if(userID)
    {
      navigate('/userAccount');
    }
    else
    {
      dispatch(setUserToggle());
      navigate('/login');
    }
  }
  //////////////////


  const [searchQuery, setSearchQuery] = useState('');

  const carts = useSelector((state) => state.carts.items);
  const noOfItems = carts.length;
  const priceTotalInt = useSelector((state) => state.carts.totalPrice);
  const priceTotal = priceTotalInt.toLocaleString();

  const handleDelete = async (id, productID, name, number, size) => {
    dispatch(deleteCart({ id, }));

    try {

      const toDeleteItem = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/deleteItem", {
        userId: userID,
        productId: productID,
        name: name,
        number: number,
        size: size,
      });

      // console.log(`\n\nThe product is saved in database\n${toDeleteItem}`)

    }
    catch (error) {
      console.error("Error in saving cart item in db, Login.js", error);
    }
  }

  return (
    <div className={styles.rootnav}>
      <nav className={styles.navbar} style={{ backgroundColor: props.bgcolor }}>
        <div className={styles.navitems}>
          <div className={styles.logoDiv}>
            <img className={styles.logo} src={logo} alt='logo' onClick={() => navigate('/home')} />
          </div>
          <div className={`centerItems ${sidebarClassName}`}>
            <div style={{ width: '100%' }}>
              <Link className={styles.navlink} to="/home">Home</Link>
            </div>
            <div style={{ width: '100%' }}>
              <Link className={styles.navlink} to="/categories">Categories</Link>
            </div>
            <div style={{ width: '100%' }}>
              <Link className={styles.navlink} to="/browseproducts">Products</Link>
            </div>
            {/* <div style={{ width: '100%' }}>
              <Link className={styles.navlink} to="/contact">Contact</Link>
            </div> */}
            <div style={{ width: '100%' }}>
              <div className={styles.navlink} style={{ color: color }} onClick={() => handleLoginOut()}>{loginOut}</div>
            </div>
          </div>
          <div className={styles.tempSpace}>

          </div>
          <div className={styles.centerSearch} style={{ display: 'flex', alignItems: 'center' }}>
            <div className={searchClassName}>
              <input
                type="text"
                placeholder="Search..."
                onChange={(e)=>setSearchQuery(e.target.value)}
                onFocus={handleSearchFocus}
                onBlur={handleSearchBlur}
              />
              <button className={styles.btn} id='hh'>
                <FontAwesomeIcon icon={faSearch}
                  onClick={handleSearchPress} />
              </button>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Link className={styles.navicons} to='/cart'
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}> <div className={styles.cartNumber}>

                  <h1>{noOfItems}</h1>

                  <FontAwesomeIcon icon={faShoppingCart} /></div></Link>
                  <div className={styles.navicons} style={{cursor:'pointer'}} onClick={()=>handleUserDashboard()}> <FontAwesomeIcon icon={faUser} /></div>

            </div>
            <div className={styles.bars}>
              <FontAwesomeIcon icon={faBars}
                onClick={handleSidebarToggle}
                onBlur={handleSidebarBlur}
              />
            </div>
          </div>
        </div>
      </nav>
      {carts.length > 0 && (
        <div className={`cartDiv ${isHovered ? 'hovered' : ''}`}>
          <div id='cartDropdown' style={{
            maxHeight: '500px',
            overflowY: 'scroll'
          }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            {carts.slice().reverse().map((cart, index) => (
              <div key={index}>
                <div className='cdItem'>
                  {cart.image && (

                    <img src={cart.image} alt="" />
                  )}
                  <div className={styles.itemBorders}>
                    <h3 style={{ fontSize: '0.7rem' }}>{cart.proName}</h3>
                    <div className={styles.pageBreak} />
                    {cart.name && <h6 style={{ padding: '0%', margin: '2%', fontWeight: '500' }}>Name = {cart.name}</h6>}
                    {cart.number && <h6 style={{ padding: '0%', margin: '2%', fontWeight: '500' }}>Number = {cart.number}</h6>}
                    <h6 style={{ padding: '0%', margin: '2%', fontWeight: '500' }}>Size = {cart.size}</h6>
                    <div className={styles.pageBreak} />
                    <h5 style={{ padding: '0%', margin: '2%', fontWeight: '500', fontSize: '0.7rem' }}>{cart.quantity} x {cart.price} PKR = {cart.subtotal.toLocaleString()}</h5>
                  </div>
                  <FontAwesomeIcon icon={faX} style={{ cursor: 'pointer' }} id='delete' onClick={() => handleDelete(cart.id, cart.productID, cart.name, cart.number, cart.size)} />
                </div>

                <div className='circleSeparate' />
              </div>
            ))}
            <div className='totalCart'>
              <p>Total:</p>
              <h3>PKR {priceTotal}</h3>
            </div>
            <button type="" onClick={goToCart}>View Cart</button>
          </div>
        </div>
      )}
      <div className={`searchTab ${isClicked ? 'clicked' : ''}`}>
        <FontAwesomeIcon icon={faX} id='closeSearch'
          onClick={() => setIsClicked(false)} />
        <div className='divSearchBar'>
          <input
            type="text"
            placeholder="Search..."
          />
          <button type='submit' className={styles.btn} id='hh'>
            <Link to='/cart'>
              <FontAwesomeIcon icon={faSearch} style={{ color: 'black' }} />
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
